import React from 'react'
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import type { OverviewTopProjectBarRow } from '../../../../utils/projectOverviewCharts'
import { overviewRechartsPalette } from './overview-recharts-palette'

export interface OverviewTopProjectsBarChartProps {
  isDark: boolean
  data: OverviewTopProjectBarRow[]
}

export function OverviewTopProjectsBarChart({
  isDark,
  data,
}: OverviewTopProjectsBarChartProps) {
  const { grid, tick, tooltipBg, tooltipBorder } = overviewRechartsPalette(isDark)

  return (
    <div className="rounded-xl shadow-md border border-slate-200 bg-white p-4 min-h-[280px]">
      <h3 className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 mb-3">
        Top projects by hours
      </h3>
      {data.length > 0 ? (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 8, right: 20, left: 4, bottom: 8 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke={grid} opacity={0.8} />
            <XAxis
              type="number"
              stroke={tick}
              tick={{ fontSize: 11 }}
              tickFormatter={(v) =>
                Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })
              }
            />
            <YAxis
              type="category"
              dataKey="name"
              stroke={tick}
              tick={{ fontSize: 11 }}
              width={110}
              interval={0}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: tooltipBg,
                border: `1px solid ${tooltipBorder}`,
                borderRadius: 8,
                fontSize: 12,
              }}
              formatter={(value: number) => [
                `${value.toLocaleString(undefined, { maximumFractionDigits: 1 })} hrs`,
                'Total hours',
              ]}
              labelFormatter={(_label, payload) =>
                (payload?.[0]?.payload as OverviewTopProjectBarRow)?.fullName ??
                _label
              }
            />
            <Bar
              dataKey="hours"
              fill="#64748b"
              stroke="#475569"
              strokeWidth={1}
              name="Total hrs"
              radius={[0, 4, 4, 0]}
              barSize={22}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[260px] flex items-center justify-center text-xs text-slate-500">
          No project data
        </div>
      )}
    </div>
  )
}
